import light from './light'
import dark from './dark'

const defaultColors = {
  base: {
    white: '#FFFFFF',
    black: '#000000'
  },
  success: '#52BB5D',
  
  errors: {
    100: '#FFE5E5',
    200: '#FFD2CF',
    600: '#E85048',
  },
  primary: {
    25: '#F9FAFE',
    40: '#F1F4F9',
    50: '#ECEFFD',
    100: '#E0E7FC',
    200: '#B9C9F9',
    300: '#8BABF8',
    400: '#7294FF',
    500: '#3069E1',
    550: '#3069E1',
    600: '#4671F6',
    700: '#193E8A',
    800: '#083170',
    900: '#001E45',
  },
  primaryDark: {
    25: '#242424',
    40: '#F1F4F9',
    50: '#393939',
    100: '#BDCEEE',
    200: '#B5CAFD',
    300: '#A4BCFD',
    400: '#658DFE',
    500: '#0F68E9',
    550: '#3069E1',
    600: '#E3E3E3',
    700: '#FCFBFC',
    800: '#083170',
    900: '#001E45',
  },
  grey:{
    100: '#FCFBFC',
    200: '#F7F7F7',
    300: '#F3F1F1',
    350: '#E8E8E8',
    400: '#DBDBDB',
    600: '#6C6C6C',
    700: '#858A94',
    800: '#474B53',
    900: '#1E1E1E',
  },
  greyDark:{
    100: '#242424',
    200: '#F7F7F7',
    300: '#2D2D2D',
    350: '#393939',
    400: '#5C5C5C',
    600: '#6C6C6C',
    700: '#858A94',
    800: '#474B53',
    900: '#1E1E1E',
  },
  accent: {
    10: '#EAF5FF',
    15: '#DFEFFF',
    30: '#BFDFFF',
    100: '#2894FF',
    200: '#1677D2',
    300: '#0F5FA8',
  },
  neutral: {
    15: '#E4E4E4',
    50: '#A4ACB8',
    80: '#7A8595',
    90: '#62728A',
    100: '#050915',
  },
  neutralDark: {
    15: '#393939',
    50: '#6D6D6D',
    80: '#A7A7A7',
    90: '#E3E3E3',
    100: '#FCFBFC',
  },
  radius: {
    xs: '4px',
    sm: '5px',
    control: '8px',
    search: '10px',
    card: '12px',
    pill: '100px',
  },
  shadows: {
    control: '0px 1px 2px rgba(0, 0, 0, 0.1)',
    hover: '0px 1px 3px rgba(0, 0, 0, 0.1)',
    menu: '0px 2px 10px rgba(0, 0, 0, 0.1)',
    card: '0px 4px 30px rgba(186, 196, 211, 0.4)',
    focus: '0px 0px 0px 3px #E0EAFF',
    focusDark: '0px 0px 0px 3px rgba(70, 113, 246, 0.5)',
    errorFocus: '0px 0px 0px 3px #FFE5E5',
    errorFocusDark: '0px 0px 0px 3px rgba(205, 58, 50, 0.4)',
  },
  shadowsDark: {
    control: '0px 1px 2px rgba(0, 0, 0, 0.35)',
    hover: '0px 1px 3px rgba(0, 0, 0, 0.35)',
    menu: '0px 2px 10px rgba(0, 0, 0, 0.45)',
    card: '0px 4px 30px rgba(0, 0, 0, 0.25)',
    focus: '0px 0px 0px 3px #E0EAFF',
    focusDark: '0px 0px 0px 3px rgba(70, 113, 246, 0.5)',
    errorFocus: '0px 0px 0px 3px #FFE5E5',
    errorFocusDark: '0px 0px 0px 3px rgba(205, 58, 50, 0.4)',
  },
  icon: {
    primary: '#2894FF',
    secondary: '#BFDFFF',
    muted: '#7A8595',
    inverse: '#FFFFFF',
  },
  iconDark: {
    primary: '#72B9FF',
    secondary: '#8BABF8',
    muted: '#A7A7A7',
    inverse: '#FCFBFC',
  }
}

export default (isDark?:boolean) => {
  return {
    isDark:isDark,
    palette: isDark ? dark.colors : light.colors,
    grey: isDark ? {...defaultColors.greyDark} : {...defaultColors.grey},
    rgb: isDark ? '36,36,36' : '255,255,255',
    base: {
      white: isDark ? defaultColors.base.black : defaultColors.base.white,
      black: isDark ? defaultColors.base.white : defaultColors.base.black
    },
    // ...defaultColors,
    primary: isDark ? {...defaultColors.primaryDark} : {...defaultColors.primary},
    accent: {...defaultColors.accent},
    neutral: isDark ? {...defaultColors.neutralDark} : {...defaultColors.neutral},
    radius: {...defaultColors.radius},
    shadows: isDark ? {...defaultColors.shadowsDark} : {...defaultColors.shadows},
    icon: isDark ? {...defaultColors.iconDark} : {...defaultColors.icon},
    success: defaultColors.success,
    errors: {...defaultColors.errors},
  }
}
